export default {
    //Facebook Comment Auto Reply
    CommentAutomations: [],
    WriteCommentAutoReplyActive: false,
    WriteCommentAutoReplyData: {},
    PageFeeds: [],
    CommentAutomationTemplates: [],
    CommentAutomationsCache: {},
    LiveStreamSellingConfigs: [],    
}